import React from "react";
import { useSearchParams } from "react-router-dom";

export default function Filter({ classFilter }) {
  const [, setSearchParams] = useSearchParams();

  function setFilter(key, value) {
    setSearchParams((param) => {
      value ? param.set(key, value) : param.delete(key);
      param.set("page", 1);
      return param;
    });
  }

  return (
    <nav>
      <div>
        <button
          className={`filter-btn ${
            classFilter === "Believers Class" ? "selected" : ""
          }`}
          onClick={() => setFilter("trainingClass", "Believers Class")}
        >
          Believers Class
        </button>
        <button
          className={`filter-btn ${
            classFilter === "Baptismal Class" ? "selected" : ""
          }`}
          onClick={() => setFilter("trainingClass", "Baptismal Class")}
        >
          Baptismal Class
        </button>
        <button
          className={`filter-btn ${
            classFilter === "Workers in Training" ? "selected" : ""
          }`}
          onClick={() => setFilter("trainingClass", "Workers in Training")}
        >
          Workers in Training
        </button>
        {classFilter && (
          <button
            className="filter-btn clear-filters"
            onClick={() => setFilter("trainingClass", null)}
          >
            Clear Filter
          </button>
        )}
      </div>
    </nav>
  );
}
